import { render, staticRenderFns } from "./ArtistsFiles.vue?vue&type=template&id=66bea866&"
import script from "./ArtistsFiles.vue?vue&type=script&lang=js&"
export * from "./ArtistsFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports